import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { StyledButton } from '../../../Components/Generics.styled';

const SelectSendToEmailContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
    align-items: center;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const StyledNavButtons = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const BackBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: 600px;
`;

const SelectSendToEmail = (props) => {
    const {
        handleNavButtonNext,
        handleNavButtonBack,
        role,
        leadGenerationData,
        setLeadGenerationData,
    } = props;
    const strongEmailRegex =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    // const emailIsValid = leadGenerationData?.emailTo.match(strongEmailRegex) !== null; // fix this later
    const emailIsValid = true;

    return (
        <SelectSendToEmailContainer>
            <Title>Where should we send the responses to?</Title>
            <StyledTextField
                id="send-to-email-text"
                label="Send To Email"
                placeholder="Where should we send the responses to?"
                value={leadGenerationData?.emailTo}
                onChange={(e) =>
                    setLeadGenerationData({
                        ...leadGenerationData,
                        emailTo: e.target.value,
                    })
                }
                variant="outlined"
                required
                error={leadGenerationData?.emailTo === '' || !emailIsValid}
                helperText={
                    !emailIsValid ? 'Email must be in correct format. Example: test@test.com' : ''
                }
            />
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                    disabled={leadGenerationData?.emailTo === '' || !emailIsValid}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </SelectSendToEmailContainer>
    );
};

SelectSendToEmail.propTypes = {
    handleNavButtonNext: propTypes.func,
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        emailTo: propTypes.string,
    }),
    setLeadGenerationData: propTypes.func,
    role: propTypes.string,
};

SelectSendToEmail.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: {},
    setLeadGenerationData: () => {},
    role: '',
};
export default SelectSendToEmail;
